import React, { useState } from "react";
import { Dialog, useMediaQuery } from "@mui/material";
import Pop1 from "./Pop1";
import Pop2 from "./Pop2";
import Vip from "./Vip";
import PpPaymentPop from "./PpPaymentPop";
import NocPaymentPop from "./NocPaymentPop";
import PurchaseDownload from "./PurchaseDownload";
import { setCurrentPopup } from "../../../store/actions/uiActions/myPermitsActions";
import { useSelector } from "react-redux";

function PromoModal() {
  const currentPopup = useSelector(
    (state) => state.myPermitsComponent.currentPopup
  );

  const tabletSize = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const [paymentState, setPaymentState] = useState(false);
  const [animationState, setAnimationState] = useState("popupGrow");
  const [textAnimationState, setTextAnimationState] = useState("popupGrow");

  const { promoModalOpen } = useSelector(
    (state) => state.myPermitsComponent.permits.modalStates
  );

  const handleTransition = (popup) => {
    if (popup === "paymentState") {
      setTextAnimationState("popupShrink");
      setTimeout(() => {
        setPaymentState(true);
        setTextAnimationState("popupGrow");
      }, 300);
    } else {
      // Start the shrinking animation
      setAnimationState("popupShrink");

      // After the shrinking animation ends (0.3s), switch the popup and grow
      setTimeout(() => {
        dispatchEvent(setCurrentPopup(popup));
        setAnimationState("popupGrow");
      }, 300); // Time here matches the duration of the shrink animation
    }
  };

  return (
    <div>
      <Dialog
        open={promoModalOpen}
        fullWidth
        maxWidth={tabletSize ? false : undefined}
        aria-labelledby="responsive-dialog-title"
        PaperProps={{
          className: animationState, // Apply the animation class dynamically
          style: tabletSize
            ? {
                width: "100%", // Set Paper width to 100%
                maxWidth: "100%", // Ensure it does not exceed 100%
                height: "auto", // Optional: in case you also want full height
                margin: 0, // Remove margins to ensure it fits to the edge
              }
            : {},
        }}
      >
        {currentPopup === "downloadPayment" ? (
          <PurchaseDownload
            textAnimationState={textAnimationState}
            paymentState={paymentState}
          />
        ) : currentPopup === "pop1" ? (
          <Pop1
            handleTransition={handleTransition}
            textAnimationState={textAnimationState}
            paymentState={paymentState}
          />
        ) : currentPopup === "pop2" ? (
          <Pop2 />
        ) : currentPopup === "vip" ? (
          <Vip handleTransition={handleTransition} />
        ) : currentPopup === "nocPaymentPop" ? (
          <NocPaymentPop />
        ) : currentPopup === "ppPaymentPop" ? (
          <PpPaymentPop />
        ) : null}
      </Dialog>
    </div>
  );
}

export default React.memo(PromoModal);
